import React from 'react';
import Logo from '@assets/images/logo.png';
import moment from 'moment/moment';

const COLORS = {
  navy: '#1a2332',
  green: '#4a7c59',
  greenCircle: '#2d5a3d',
  pageBg: '#f5f5f0',
  border: '#e0e0d8',
  text: '#444444',
  white: '#ffffff'
};

const sectionBox = {
  backgroundColor: COLORS.white,
  border: `1px solid ${COLORS.border}`,
  marginBottom: '12px'
};

const sectionBoxAccent = {
  ...sectionBox,
  borderLeft: `4px solid ${COLORS.green}`
};

const sectionHeaderRow = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '12px 14px',
  fontSize: '14px',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  color: COLORS.navy
};

const sectionBody = {
  padding: '12px 14px',
  fontSize: '13px',
  color: COLORS.text,
  lineHeight: '20px'
};

const listStyle = {
  marginTop: '0px',
  marginBottom: '0px',
  paddingLeft: '18px',
  fontSize: '13px',
  color: COLORS.text,
  lineHeight: '20px'
};

const linkStyle = { color: COLORS.green };
const linkStyleBold = { color: COLORS.green, fontWeight: 500 };

const circleStyle = {
  width: '36px',
  height: '36px',
  minWidth: '36px',
  borderRadius: '50%',
  backgroundColor: COLORS.greenCircle,
  color: COLORS.white,
  fontSize: '16px',
  fontWeight: 'bold',
  textAlign: 'center',
  lineHeight: '36px',
  marginRight: '12px'
};

const attachmentTitle = {
  fontWeight: 'bold',
  color: COLORS.navy,
  fontSize: '14px'
};

const shieldIcon = (
  <svg width="28" height="28" viewBox="0 0 24 24" fill={COLORS.green}>
    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
  </svg>
);

const docIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill={COLORS.green}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
  </svg>
);

const phoneIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill={COLORS.green}>
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
  </svg>
);



export default props => {
  const addressArr = [];
  if (props.entity.unit !== null) {
    addressArr.push(props.entity.unit.street);
    if (
      props.entity.unit.unit_no !== null &&
      props.entity.unit.unit_no.length > 0
    ) {
      addressArr.push('#' + props.entity.unit.unit_no);
    }
  }
  if (props.entity.association !== null) {
    addressArr.push(props.entity.association.city);
    addressArr.push(props.entity.association.state);
    addressArr.push(props.entity.association.zip_code);
  }

  const address = addressArr.filter(n => n).join(', ');

  const sectionHeader = title => (
    <div style={sectionHeaderRow}>
      <span>{title}</span>
      {docIcon}
    </div>
  );

  const attachmentBox = (number, title, body) => (
    <div
      style={{
        ...sectionBox,
        display: 'flex',
        alignItems: 'flex-start',
        padding: '12px 14px'
      }}
    >
      <div style={circleStyle}>{number}</div>
      <div style={{ flex: 1 }}>
        <div style={{ ...attachmentTitle, marginBottom: body ? '6px' : '0px' }}>
          {title}
        </div>
        {body}
      </div>
    </div>
  );

  const issueDate = moment(props.entity.issue_date * 1000).format('MM/DD/YYYY');
  return (
    <div style={{ backgroundColor: COLORS.pageBg, padding: '16px' }}>
      <div
        style={{
          backgroundColor: COLORS.navy,
          padding: '16px 20px',
          display: 'flex',
          alignItems: 'center',
          marginBottom: '12px'
        }}
      >
        <div>
          <div
            style={{
              color: COLORS.white,
              fontWeight: 'bold',
              fontSize: '24px',
              lineHeight: '26px'
            }}
          >
            NEXTIER
          </div>
          <div
            style={{
              color: COLORS.white,
              fontSize: '10px',
              letterSpacing: '2px'
            }}
          >
            INSURANCE SERVICES
          </div>
        </div>
        <div
          style={{
            width: '2px',
            height: '40px',
            backgroundColor: COLORS.green,
            margin: '0 16px'
          }}
        />
        <div style={{ color: COLORS.white, fontSize: '16px', flex: 1 }}>
          Evidence of Insurance Documents
        </div>
        <div>{shieldIcon}</div>
      </div>
      {props.entity.master_cert_only === 1 ? (
        
        <React.Fragment>
            <div style={sectionBoxAccent}>
              {sectionHeader('EVIDENCE OF INSURANCE DOCUMENT DELIVERY  ')}
              <div style={sectionBody}>
                This is an automated document delivery notification. Please see the attached
                Evidence of Insurance documents for the association listed below.
              </div>
            </div>
          <div style={sectionBoxAccent}>
            <div style={sectionBody}>
              <div>
                <strong>Association:</strong> {props.entity.association !== null
                ? props.entity.association.name
                : ''}
              </div>
              <div>
                <strong>Date Issued:</strong> {issueDate}
              </div>
              
            </div>
          </div>

          <div style={sectionBoxAccent}>
            {sectionHeader('Documents Included')}
            {sectionHeader('Evidence of Property Insurance Document(s), ACORD 25')}
            <div style={sectionBody}>
              <div>
                Please review the <strong>Remarks</strong> section for specific policy details, coverage notes,
                limits, and applicable conditions. If applicable, please also refer to the additional
                pages for further policy, coverage, and lending question clarifications.
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div style={sectionBoxAccent}>
            {sectionHeader('CUSTOM EVIDENCE OF INSURANCE DOCUMENT DELIVERY')}
            <div style={sectionBody}>
              This is an automated document delivery notification. Please see the attached
              Custom Evidence of Insurance documents for the request listed below.
            </div>
          </div>
          
          <div style={sectionBoxAccent}>
            <div style={sectionBody}>
              <div>
                <strong>Name:</strong> {props.entity.owner_first_name}{' '}
                {props.entity.owner_last_name}
                {props.entity.second_owner_first_name !== null &&
                  props.entity.second_owner_first_name.length > 0 && (
                    <React.Fragment>
                      {' '}
                      and {props.entity.second_owner_first_name}{' '}
                      {props.entity.second_owner_last_name}
                    </React.Fragment>
                  )}
              </div>
              <div>
                <strong>Loan Number:</strong> {props.entity.loan_number_1}
              </div>
              <div>
                <strong>Association:</strong>{' '}
                {props.entity.association !== null
                  ? props.entity.association.name
                  : ''}
              </div>
              <div>
                <strong>Property Address:</strong> {address}
              </div>
              <div>
                <strong>Date Issued:</strong> {issueDate}
              </div>
              {props.entity.escrow_number !== null &&
                props.entity.escrow_number.length > 0 && (
                  <div>
                    <strong>Escrow #:</strong> {props.entity.escrow_number}
                  </div>
                )}
            </div>
          </div>

          <div style={sectionBoxAccent}>
            {sectionHeader('Documents Included')}
            {sectionHeader('Evidence of Property Insurance Document(s), ACORD 27')}
            <div style={sectionBody}>
              <div>
                Please review the Remarks section for specific policy details, coverage notes, limits,
                and applicable conditions. If applicable, please also refer to the additional pages
                for further policy, coverage, and lending question clarifications.
              </div>
            </div>
          </div>

        </React.Fragment>
      )}

      <div style={sectionBoxAccent}>
        {sectionHeader('Important Notes')}
        <div style={sectionBody}>
          <div>
            These documents have been prepared based on the information provided in the
            request and the policy information available at the time of processing.<br/><br/>
            Please carefully review all information included on the certificate, including any
            remarks and additional pages. This certificate is intended to be comprehensive
            based on the information available at the time of processing, and no further
            explanations or supplemental clarifications will be provided.
          </div>
        </div>
      </div>

      <div style={sectionBoxAccent}>
        <div style={sectionBody}>
          <p>
            Thank you,
            <br />
            Processing Department<br/>
            NEXTIER Insurance Services
          </p>
        </div>
      </div>
    </div>
  );
};
